
const digest = '8ec79a566eb6376f48baa3add998c90b7660231c66cb0ddd76f675ecef38180c';
const classes = {"item":"_item_1oepl_1","active":"_active_1oepl_14","iconWrapper":"_iconWrapper_1oepl_20"};
const css = `._item_1oepl_1 {
  font-size: 16px;
  color: #3e3f42;
  background-color: #f2f4f7;
  border: 1px solid #eaedf3;
  padding: 6px 12px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
}
._item_1oepl_1._active_1oepl_14 {
  background-color: #ffffff;
  border-bottom-color: #ffffff;
  color: #619612;
  font-weight: 500;
}
._item_1oepl_1 ._iconWrapper_1oepl_20 {
  display: flex;
}
._item_1oepl_1 ._iconWrapper_1oepl_20 img {
  height: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  